import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  textCard: {
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    paddingLeft: "5px",
    paddingRight: "5px",
    borderRadius: "10px",
  },

  textBox: {
    padding: "2px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#F0B90B",
    "@media (max-width: 900px)": {
      fontSize: "10px",
    },
  },
  walletBox: {
    cursor: "pointer",
  },
}));

const connectMetamask = async () => {
  window.ethereum &&
    (await window.ethereum.request({ method: "eth_requestAccounts" }));
};

const AddressCard = ({ account }) => {
  const { textBox, textCard, walletBox } = useStyles();
  return (
    <div className={textCard}>
      <div className={textBox}>
        {account ? (
          <p>{account}</p>
        ) : (
          <p className={walletBox} onClick={connectMetamask}>
            Connect Metamask
          </p>
        )}
      </div>
    </div>
  );
};

export default AddressCard;
